<template>
  <div class="app-menu">
    <app-menu-item
      v-for="(menuItem, index) in view.menuItems"
      :key="index"
      :icon="menuItem.icon"
      :link="menuItem.link"
      :text="menuItem.text"
      :isActive="view.isItemActive(menuItem)"
    />
  </div>
</template>

<script setup lang="ts">
import { HeaderView } from '@/models/header'

import AppMenuItem from './AppMenuItem.vue'

defineProps<{
  view: HeaderView
}>()
</script>

<style lang="scss" scoped>
.app-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  @media only screen and (max-width: $w-max-content-width) {
    gap: 16px;
  }
  @media only screen and (max-width: $w-tablet-s) {
    justify-content: space-between;
    gap: unset;
  }
}
</style>
